import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { School, Users, Heart, TrendingUp } from "lucide-react";

const LandingPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen" style={{ background: "linear-gradient(to bottom, #F8FBFD 0%, #E8F4F9 100%)" }}>
      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16 animate-fade-in">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold mb-6" style={{ color: "#2C5F7F" }}>
            HostelConnect
          </h1>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto mb-8">
            Bridge the gap between hostels and parents. Track your child's development, health, and activities in real-time.
          </p>
          <Button
            data-testid="get-started-btn"
            onClick={() => navigate("/login")}
            className="btn-primary text-white px-8 py-6 text-lg rounded-full font-semibold"
          >
            Get Started
          </Button>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mt-20">
          <div className="glass-effect rounded-2xl p-8 card-hover animate-slide-up">
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
              <School className="w-8 h-8" style={{ color: "#7CB9E8" }} />
            </div>
            <h3 className="text-xl font-semibold mb-3" style={{ color: "#2C5F7F" }}>
              Student Management
            </h3>
            <p className="text-gray-600">
              Comprehensive student profiles with photos, attendance, and academic records
            </p>
          </div>

          <div className="glass-effect rounded-2xl p-8 card-hover animate-slide-up" style={{ animationDelay: "0.1s" }}>
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
              <Heart className="w-8 h-8" style={{ color: "#7CB9E8" }} />
            </div>
            <h3 className="text-xl font-semibold mb-3" style={{ color: "#2C5F7F" }}>
              Health Tracking
            </h3>
            <p className="text-gray-600">
              Monitor health checkups, medications, and vaccinations with instant parent notifications
            </p>
          </div>

          <div className="glass-effect rounded-2xl p-8 card-hover animate-slide-up" style={{ animationDelay: "0.2s" }}>
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
              <Users className="w-8 h-8" style={{ color: "#7CB9E8" }} />
            </div>
            <h3 className="text-xl font-semibold mb-3" style={{ color: "#2C5F7F" }}>
              Parent Portal
            </h3>
            <p className="text-gray-600">
              Secure access for parents to view their child's progress, attendance, and activities
            </p>
          </div>

          <div className="glass-effect rounded-2xl p-8 card-hover animate-slide-up" style={{ animationDelay: "0.3s" }}>
            <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mb-4">
              <TrendingUp className="w-8 h-8" style={{ color: "#7CB9E8" }} />
            </div>
            <h3 className="text-xl font-semibold mb-3" style={{ color: "#2C5F7F" }}>
              Weekly Reports
            </h3>
            <p className="text-gray-600">
              Automated weekly summaries with attendance, health notes, and activity highlights
            </p>
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-24 text-center glass-effect rounded-3xl p-12 animate-fade-in">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: "#2C5F7F" }}>
            Ready to connect?
          </h2>
          <p className="text-lg text-gray-600 mb-8">
            Join hostels and parents already using HostelConnect
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              data-testid="warden-login-btn"
              onClick={() => navigate("/login?role=warden")}
              className="btn-primary text-white px-8 py-4 text-lg rounded-full font-semibold"
            >
              Warden Login
            </Button>
            <Button
              data-testid="parent-login-btn"
              onClick={() => navigate("/login?role=parent")}
              variant="outline"
              className="border-2 px-8 py-4 text-lg rounded-full font-semibold"
              style={{ borderColor: "#7CB9E8", color: "#2C5F7F" }}
            >
              Parent Login
            </Button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-20 py-8 text-center text-gray-600">
        <p>&copy; 2025 HostelConnect. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LandingPage;